(function ($, Cobalt, undefined) {
    Cobalt.Reports = {
        initialize: function () {

            Cobalt.runOnHtmlInsert(Cobalt.Reports.bindReportModalDescriptions);

            var reportDetails = $(".j-cp-report");
            if (reportDetails.length > 0) {
                // Status changed
                var reportInfo = $("#report-info");
                var reportInfoParent = reportInfo.parent();
                reportDetails.delegate("#reported-entity-quick-update-form input:radio", "change", function () {
                    var form = $("#reported-entity-quick-update-form");
                    reportInfoParent.mask();
                    form.ajaxSubmit(function (data) {
                        window.location.reload();
                    });
                });
            }

            if ($("div.j-comment").first().data("revision-number") > 0) {
                //hook up the comment revision 
                $("div.j-comment").each(function () {
                    var $comment = $(this);
                    handleRevisions($comment);
                });

                //hook up all revision links
                $("a.revision-report").each(function () {
                    var $link = $(this);
                    $link.on("click", function () {
                        var revisionNumber = $(this).data("revision-id");
                        var $selectRevisions = $("select.j-comment-revisions-select");
                        $selectRevisions.val(revisionNumber).trigger('change');
                    });
                });
            }

        },
        bindReportModalDescriptions: function () {
            var selectField = $('select#field-report-reason');
            selectField.unbind('change');
            selectField.change(function () {
                var selectedOption = $(this).find('option:selected');
                if (selectedOption.text() === "—") {
                    $(this).parents("div#form-field-report-reason").find("div#report-description").remove();
                    return;
                }
                $(this).parents("div#form-field-report-reason").find("div#report-description").remove();
                $(this).parents("div#form-field-report-reason").append("<div id=\"report-description\">" + selectedOption.attr("data-report-description") + "</div>");
            });
        },
    };

    var commentRevisions = [];
    function Revision(commentID, revisionID, body, processedBody, revisionStatus, commentStatus) {
        this.commentID = commentID;
        this.revisionID = revisionID;
        this.body = body;
        this.processedBody = processedBody;
        this.revisionStatus = revisionStatus;
        this.commentStatus = commentStatus;
    }
    function getRevision(commentID, revisionID) {
        if (commentRevisions.length > 0) {
            return $.grep(commentRevisions, function (r) { return r.commentID === commentID && r.revisionID === revisionID; })[0];
        }
    }

    function handleRevisions($comment) {
        var $commentRevisions = $comment.find(".j-comment-revisions-history");
        if ($commentRevisions.length > 0) {

            //get revisions
            
            var $selectRevisions = $comment.find(".j-comment-revisions-select");
                if ($selectRevisions.find("option").length <= 0) {
                    $comment.mask();
                    var cid = $comment.data("id");
                    $.get(Cobalt.Routes.Instance.CommentGetCommentRevisions($comment.data("id")), function (data) {
                        if (data) {
                            if (data.revisions && data.revisions.length > 0) {
                                data.revisions = $.parseJSON(data.revisions);
                                $selectRevisions.append("<option value='0'>-</option>");
                                var currentMarkup = $comment.find(".j-comment-body").html();
                                commentRevisions.push(new Revision($comment.data("id"), 0, currentMarkup, currentMarkup, data.revisionStatus));
                                for (var i = 0; i < data.revisions.length; i++) {
                                    if (i === 0) {
                                        $comment.commentStatus = data.revisions[0].commentStatus;
                                    }
                                    var rev = data.revisions[i];
                                    $selectRevisions.append("<option value='" + rev.revisionNumber + "'>#" + rev.revisionNumber + " " + rev.dateCreated + " by: " + rev.author + (rev.revisionStatus !== undefined ? "(" + rev.revisionStatus + ")" : "") + "</option>");
                                }
                            }
                        }
                        var currentVerisionNumber = $comment.data("revision-number");
                        $selectRevisions.val(currentVerisionNumber);
                        $comment.unmask();
                    });
                }

                highlightRevisions($comment.data("revision-number"));
           

            $comment.on("change", ".j-comment-revisions-select", function () {
                //get rendered version
                var $selectedOption = $(this).find("option:selected");

                var setBody = function (processedBody) {
                    $comment.find(".j-comment-body").empty().append(processedBody);
                };
              
                if ($selectedOption.index() === 0) { //for current
                    var currentMarkup = getRevision($comment.data("id"), 0);
                    if (currentMarkup) {
                        setBody(currentMarkup.processedBody);
                    }
                    return;
                }

                var commentID = $comment.data("id");
                var revisionNumber = $selectedOption.val();
                var tryGetRevision = getRevision(commentID, revisionNumber);
                if (!tryGetRevision) {
                    $comment.mask();
                    $.get(Cobalt.Routes.Instance.CommentGetCommentRevision(commentID, revisionNumber), function (data) {
                        if (data) {
                            if (data.status === "success") {
                                commentRevisions.push(new Revision(commentID, revisionNumber, data.body, data.processedBody, data.revisionStatus));
                                setBody(data.processedBody);                            
                            }
                        }
                        $comment.unmask();
                    });
                }
                else {
                    setBody(tryGetRevision.processedBody);
                }

                highlightRevisions(revisionNumber);
            });
        }
    }

    function highlightRevisions(revisionNum) {
        $("div.j-comment").each(function () {
            var $comment = $(this);
            var revNum = $comment.data("revision-id");
            if (revNum == revisionNum) {
                $comment.addClass("revision-highlight");
            }
            else {
                $comment.removeClass("revision-highlight");
            }
        });
    }

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Reports.js